var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"LoginContent d-flex justify-end"},[(_vm.IsMovil)?_c('div',{staticClass:"LogoCont"},[_c('img',{staticClass:"LogoMovil",attrs:{"src":require("@/assets/img/logo.svg")}})]):_vm._e(),_c('LoginComponent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }